import { API_BASE_URL, API_KEY } from '../../constants';

/**
 * Fetches analytics data from the API for a specific period and facility.
 * @param {'daily' | 'monthly' | 'yearly'} period - The time period for the analytics.
 * @param {number} centreId - The ID of the facility.
 * @returns {Promise<any>} A promise that resolves to the analytics data object.
 * @throws {Error} If the API call fails.
 */
export const fetchAnalytics = async (period: 'daily' | 'monthly' | 'yearly', centreId: number): Promise<any> => {
  const url = `${API_BASE_URL}/analytics?period=${period}&centre_id=${centreId}`;
  
  const response = await fetch(url, {
    headers: {
      'x-api-key': API_KEY,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Analytics API call failed for period '${period}' with status ${response.status}: ${errorText}`);
  }

  // The API might return a JSON string inside a JSON response body (double encoded).
  // This robustly handles both that case and a standard JSON object response.
  const data = await response.json();
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error('Failed to parse double-encoded JSON from analytics API', e);
      throw new Error(`Invalid JSON response from analytics API for period '${period}'.`);
    }
  }
  return data;
};
